import { Card, ListGroup } from 'react-bootstrap';
import { Outlet, NavLink } from 'react-router-dom';
import { VehicleMatches } from './VehicleMatches';

export function ReportsPage() {
    // Quick stats calculation
    const recs = VehicleMatches;
    const verifiedCount = Math.floor(recs.length * 0.6);
    const candidateCount = recs.length - verifiedCount;

    return (
        <div className="h-100">
            <div id="capture-list-page">
                <div id="capture-list" className="y-scroll">
                    <div className="bg-body-secondary p-3 mb-0 h3">Reports</div>
                    <ListGroup variant="flush">
                        <NavLink
                            to="/report/overview"
                            className={({ isActive }) => `list-group-item list-group-item-action d-flex align-items-center ${isActive ? 'active' : ''}`}>
                            <i className="bi bi-grid-3x3-gap me-3"></i>
                            Overview
                        </NavLink>
                    </ListGroup>

                    <div className="px-3 mt-4">
                        <h6 className="text-muted mb-3">Quick Stats</h6>
                        <Card className="mb-2 border-0 bg-light">
                            <Card.Body className="py-2 px-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted small">Total Vehicles</span>
                                    <span className="fw-bold">{recs.length}</span>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-2 border-0 bg-light">
                            <Card.Body className="py-2 px-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted small">Verified</span>
                                    <span className="fw-bold text-success">{verifiedCount}</span>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-2 border-0 bg-light">
                            <Card.Body className="py-2 px-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted small">Pending</span>
                                    <span className="fw-bold text-warning">{candidateCount}</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <div className="image-viewer h-100 overflow-hidden position-relative bg-light y-scroll">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}